import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const mode = 'history'

const routes = [
	{
		path: '/',
		name: 'home',
		component: (resolve) => {
			require(['../views/home'], resolve)
		},
		meta: {
			title: '首页',
			Auth: true,
			index: 0, //页面层级
			name: 'home'
		}
	},
	{
		path: '/staff/list',
		name: 'stafflist',
		component: (resolve) => {
			require(['../views/staff/list'], resolve)
		},
		meta: {
			title: '员工列表',
			Auth: true,
			index: 1
		}
	},
	{
		path: '/staff/detail',
		name: 'employerDetail',
		component: (resolve) => {
			require(['../views/staff/detail'], resolve)
		},
		meta: {
			title: '员工详情',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/staff/addEmployer',
		name: 'addEmployer',
		component: (resolve) => {
			require(['../views/staff/addEmployer'], resolve)
		},
		meta: {
			title: '添加员工',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/staff/editEmployer',
		name: 'editEmployer',
		component: (resolve) => {
			require(['../views/staff/editEmployer'], resolve)
		},
		meta: {
			title: '编辑员工',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/store/list',
		name: 'storelist',
		component: (resolve) => {
			require(['../views/shop/list'], resolve)
		},
		meta: {
			title: '门店列表',
			Auth: true,
			index: 1
		}
	},
	{
		path: '/login',
		name: 'login',
		component: (resolve) => {
			require(['../views/account/login'], resolve)
		},
		meta: {
			title: '',
			index: 0
		}
	},
	{//回调页面
		path: '/LoginCallBack',
		name: 'LoginCallBack',
		component: (resolve) => {
			require(['../views/account/LoginCallBack'], resolve)
		},
		meta: {
			title: '',
			index: 1
		}
	},
	{
		path: '/forgetpwd',
		name: 'forgetpwd',
		component: (resolve) => {
			require(['../views/account/forgetpwd'], resolve)
		},
		meta: {
			title: '设置新密码',
			index: 1,
			Auth: false
		}
	},
	{
		path: '/order/list',
		name: 'orderlist',
		component: (resolve) => {
			require(['../views/order/OrderList'], resolve)
		},
		meta: {
			title: '订单列表',
			Auth: true,
			index: 1
		}
	},
	{
		path: '/order/detail',
		name: 'orderdetail',
		component: (resolve) => {
			require(['../views/order/OrderDetail'], resolve)
		},
		meta: {
			title: '订单明细',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/order/show',
		name: 'ordershow',
		component: (resolve) => {
			require(['../views/order/OrderDetailShow'], resolve)
		},
		meta: {
			title: '订单详情',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/order/repaireve',
		name: 'orderrepaireve',
		component: (resolve) => {
			require(['../views/order/OrderRepairEve'], resolve)
		},
		meta: {
			title: '订单详情',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/order/repairplatform',
		name: 'orderrepairplatform',
		component: (resolve) => {
			require(['../views/order/OrderRepairPlatform'], resolve)
		},
		meta: {
			title: '维修台',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/order/waitpay',
		name: 'orderwaitpay',
		component: (resolve) => {
			require(['../views/order/OrderWaitPay'], resolve)
		},
		meta: {
			title: '订单详情',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/order/dismissed',
		name: 'orderdismissed',
		component: (resolve) => {
			require(['../views/order/OrderDismissed'], resolve)
		},
		meta: {
			title: '订单驳回',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/order/dismisseddetail',
		name: 'orderdismisseddetail',
		component: (resolve) => {
			require(['../views/order/OrderDismissed'], resolve)
		},
		meta: {
			title: '订单驳回',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/order/DetailStore',
		name: 'OrderDetailStore',
		component: (resolve) => {
			require(['../views/order/OrderDetailStore'], resolve)
		},
		meta: {
			title: '订单明细门店',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/order/orderReceiveMoney',
		name: 'OrderReceiveMoney',
		component: (resolve) => {
			require(['../views/order/OrderReceiveMoney'], resolve)
		},
		meta: {
			title: '收款',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/order/orderReceiveMoneyEnd',
		name: 'OrderReceiveMoneyEnd',
		component: (resolve) => {
			require(['../views/order/OrderReceiveMoneyEnd'], resolve)
		},
		meta: {
			title: '收款',
			Auth: true,
			index: 0
		}
	},
	{
		path: '/order/orderComment',
		name: 'OrderComment',
		component: (resolve) => {
			require(['../views/order/OrderComment'], resolve)
		},
		meta: {
			title: '评价',
			Auth: true,
			index: 0
		}
	},
	{
		path: '/order/orderfill',
		name: 'OrderFill',
		component: (resolve) => {
			require(['../views/order/OrderFill'], resolve)
		},
		meta: {
			title: '门店出货下单',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/order/orderfill',
		name: 'OrderFill2',
		component: (resolve) => {
			require(['../views/order/OrderFill'], resolve)
		},
		meta: {
			title: '扫码用户配件下单',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/order/orderfill',
		name: 'OrderFill3',
		component: (resolve) => {
			require(['../views/order/OrderFill'], resolve)
		},
		meta: {
			title: '门店出货下单',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/reportform',
		name: 'reportform',
		component: (resolve) => {
			require(['../views/report/Reportform'], resolve)
		},
		meta: {
			title: '报表',
			Auth: true,
			index: 1
		}
	}, {
		path: '/announcement',
		name: 'announcement',
		component: (resolve) => {
			require(['../views/announcement/center'], resolve)
		},

		meta: {
			title: '消息',
			Auth: true,
			index: 1
		}
	},
	{
		path: '/trouble/index',
		name: 'trouble',
		component: (resolve) => {
			require(['../views/trouble/index'], resolve)
		},
		meta: {
			title: '故障选择',
			Auth: true,
			index: 1
		}
	},
	{
		path: '/withdraw',
		name: 'withdraw',
		component: (resolve) => {
			require(['../views/asset/Withdraw'], resolve)
		},
		meta: {
			title: '提现',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/qualityAssuranceAdd',
		name: 'qualityAssuranceAdd',
		component: (resolve) => {
			require(['../views/qualityAssurance/QualityAssuranceAdd'], resolve)
		},
		meta: {
			title: '提交质保',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/support',
		name: 'support',
		component: (resolve) => {
			require(['../views/qualityAssurance/Support'], resolve)
		},
		meta: {
			title: '售后',
			Auth: true,
			index: 1
		}
	},
	{
		path: '/getqualityassurancelist',
		name: 'getqualityassurancelist',
		component: (resolve) => {
			require(['../views/qualityAssurance/GetQualityAssuranceList'], resolve)
		},
		meta: {
			title: '质保记录',
			Auth: true,
			index: 4,
		}
	},
	{
		path: '/getqualityassuranceresult',
		name: 'getqualityassuranceresult',
		component: (resolve) => {
			require(['../views/qualityAssurance/QualityAssuranceResult'], resolve)
		},
		meta: {
			title: '查询结果',
			Auth: true,
			index: 4,
		}
	},
	{
		path: '/getqualityassurancedetail/:id',
		name: 'getqualityassurancedetail',
		component: (resolve) => {
			require(['../views/qualityAssurance/QualityAssuranceDetail'], resolve)
		},
		meta: {
			title: '质保详情',
			Auth: true,
			index: 5,
		}
	},
	{
		path: '/getqualityassurancedetailresult/:id',
		name: 'getqualityassurancedetailresult',
		component: (resolve) => {
			require(['../views/qualityAssurance/QualityAssuranceDetailResult'], resolve)
		},
		meta: {
			title: '质保详情',
			Auth: true,
			index: 5,
		}
	},

	{
		path: '/getqualityassurancelist/qualitycancel/:id',
		name: 'qualitycancel',
		component: (resolve) => {
			require(['../views/qualityAssurance/qualitycancel'], resolve)
		},
		meta: {
			title: '取消售后',
			Auth: true,
			index: 5
		}
	},
	{
		path: '/getqualityassurancelist/aftersalehandle/:id',
		name: 'aftersalehandle',
		component: (resolve) => {
			require(['../views/qualityAssurance/AfterSaleHandle'], resolve)
		},
		meta: {
			title: '售后处理',
			Auth: true,
			index: 5
		}
	},
	{
		path: '/getqualityassurancelist/aftersalehandleend',
		name: 'aftersalehandleend',
		component: (resolve) => {
			require(['../views/qualityAssurance/AfterSaleHandleEnd'], resolve)
		},
		meta: {
			title: '售后处理完成',
			Auth: true,
			index: 6
		}
	},
	{
		path: '/my',
		name: 'my',
		component: (resolve) => {
			require(['../views/myperson/my'], resolve)
		},
		meta: {
			title: '我的',
			Auth: true,
			index: 1
		}
	},
	{
		path: '/about',
		name: 'about',
		component: (resolve) => {
			require(['../views/myperson/about'], resolve)
		},
		meta: {
			title: '关于我们',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/lawclause',
		name: 'lawclause',
		component: (resolve) => {
			require(['../views/myperson/lawclause'], resolve)
		},
		meta: {
			title: '隐私政策',
			Auth: false,
			index: 3,
			public: true
		}
	},
	{
		path: '/qualityAssuranceQuery',
		name: 'qualityAssuranceQuery',
		component: (resolve) => {
			require(['../views/qualityAssurance/qualityAssuranceQuery'], resolve)
		},
		meta: {
			title: '质保查询',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/noticeList',
		name: 'noticeList',
		component: (resolve) => {
			require(['../views/announcement/noticeList'], resolve)
		},

		meta: {
			title: '通知列表',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/noticeDetail/:id',
		name: 'noticeDetail',
		component: (resolve) => {
			require(['../views/announcement/noticeDetail'], resolve)
		},

		meta: {
			title: '通知详情',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/messageList',
		name: 'messageList',
		component: (resolve) => {
			require(['../views/announcement/messageList'], resolve)
		},

		meta: {
			title: '消息列表',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/messageDetail/:id',
		name: 'messageDetail',
		component: (resolve) => {
			require(['../views/announcement/messageDetail'], resolve)
		},

		meta: {
			title: '消息详情',
			Auth: true,
			index: 3
		}
	}
	,
	{
		path: '/demo',
		name: 'demo',
		component: (resolve) => {
			require(['../views/demo/index'], resolve)
		},

		meta: {
			title: 'demo',
			Auth: true,
			index: 4
		}
	},
	{
		path: '/recycle',
		name: 'recycle',
		component: (resolve) => {
			require(['../views/recycle/list'], resolve)
		},

		meta: {
			title: '回收',
			Auth: true,
			index: 1
		}
	},
	{
		path: '/recycle/storelist',
		name: 'recyclestorelist',
		component: (resolve) => {
			require(['../views/recycle/storelist'], resolve)
		},

		meta: {
			title: '选择门店',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/recycle/qrcode',
		name: 'recycleqrcode',
		component: (resolve) => {
			require(['../views/recycle/qrcode'], resolve)
		},

		meta: {
			title: '回收二维码',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/order/douyinservicecodeorder',
		name: 'douyinservicecodeorder',
		component: (resolve) => {
			require(['../views/order/DouYinServiceCodeOrder'], resolve)
		},
		meta: {
			title: '抖音扫码验券',
			Auth: true,
			index: 1
		}
	},
	{
				path: '/order/ksservicecodeorder',
				name: 'ksservicecodeorder',
				component: (resolve) => {
						require(['../views/order/KSServiceCodeOrder'], resolve)
				},
				meta: {
						title: '快手扫码验券',
						Auth: true,
						index: 1
				}
		},
		{
				path: '/order/ksservicecodeorderdetail',
				name: 'ksServiceCodeOrderDetail',
				component: (resolve) => {
						require(['../views/order/KSServiceCodeOrderDetail'], resolve)
				},
				meta: {
						title: '快手服务码订单',
						Auth: true,
						index: 1
				}
		},
	{
		path: '/order/servicecodeorder',
		name: 'servicecodeorder',
		component: (resolve) => {
			require(['../views/order/ServiceCodeOrder'], resolve)
		},
		meta: {
			title: '服务码下单',
			Auth: true,
			index: 1
		}
	},
	{
		path: '/order/setorder',
		name: 'setorder',
		component: (resolve) => {
			require(['../views/order/SetOrder'], resolve)
		},
		meta: {
			title: '下单',
			Auth: true,
			index: 2
		}
	},
	{

		path: '/order/setorderceshi',
		name: 'setorderceshi',
		component: (resolve) => {
			require(['../views/order/SetOrderCeShi'], resolve)
		},
		meta: {
			title: '测试下单',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/order/servicecodeorderdetail',
		name: 'servicecodeorderdetail',
		component: (resolve) => {
			require(['../views/order/ServicecodeOrderDetail'], resolve)
		},
		meta: {
			title: '服务码订单',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/order/douyinservicecodeorderdetail',
		name: 'douyinservicecodeorderdetail',
		component: (resolve) => {
			require(['../views/order/DouYinServiceCodeOrderDetail'], resolve)
		},
		meta: {
			title: '抖音服务码订单',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/order/servicecoderesend',
		name: 'servicecoderesend',
		component: (resolve) => {
			require(['../views/order/ServiceCodeResend'], resolve)
		},
		meta: {
			title: '重发服务码',
			Auth: true,
			index: 3
		}
	},
	{
		path: '/companyrecord',
		name: 'companyrecord',
		component: (resolve) => {
			require(['../views/account/CompanyRecord'], resolve)
		},
		meta: {
			title: '完善商家资料',
			index: 0,
			Auth: false
		}
	},
	{
		path: '/protocol',
		name: 'protocol',
		component: (resolve) => {
			require(['../views/account/RegisterProtocol'], resolve)
		},
		meta: {
			title: '服务协议',
			index: 3,
			Auth: false,
			public: true
		}
	},
	{
		path: '/repairCertificate/check',
		name: 'repairCertificatecheck',
		component: (resolve) => {
			require(['../views/repairCertificate/check'], resolve)
		},
		meta: {
			title: '客户确认签字',
			index: 2,
			Auth: true
		}
	},
	{
		path: '/repairCertificate/create',
		name: 'repairCertificatecreate',
		component: (resolve) => {
			require(['../views/repairCertificate/create'], resolve)
		},
		meta: {
			title: '接机单',
			index: 2,
			Auth: true,
			hideBack: true,
			transitionName: "updown"
		}
	},
	{
		path: '/repairCertificate/confirm',
		name: 'repairCertificateconfirm',
		component: (resolve) => {
			require(['../views/repairCertificate/confirm'], resolve)
		},
		meta: {
			title: '接机单',
			index: 3,
			Auth: true,
			transitionName: "updown"
		}
	},
	{
		path: '/store/records',
		name: 'storerecods',
		component: (resolve) => {
			require(['../views/store/records'], resolve)
		},
		meta: {
			title: '入库记录',
			index: 2,
			Auth: true
		}
	},
	{
		path: '/store/add',
		name: 'storeadd',
		component: (resolve) => {
			require(['../views/store/add'], resolve)
		},
		meta: {
			title: '零采入库',
			index: 1,
			Auth: true
		}
	},
	{
		path: '/repairCertificate/SmallTicket',
		name: 'smallTicket',
		component: (resolve) => {
			require(['../views/repairCertificate/SmallTicket'], resolve)
		},
		meta: {
			title: '服务信息',
			index: 0,
			Auth: false,
			transitionName: 'slide-up'
		}
	},
	{
		path: '/repairCertificate/SmallTicket1',
		name: 'smallTicket1',
		component: (resolve) => {
			require(['../views/repairCertificate/SmallTicket'], resolve)
		},
		meta: {
			title: '服务信息',
			index: 4,
			Auth: true,
		}
	},
	{
		path: '/note/notepage',
		name: 'notepage',
		component: (resolve) => {
			require(['../views/note/NotePage'], resolve)
		},
		meta: {
			title: '',
			index: 1,
			Auth: true,
			transitionName: 'updown',
			disableLR: true,
			hideBack: true
		}
	},
	{
		path: '/order/setorderall',
		name: 'setorderall',
		component: (resolve) => {
			require(['../views/order/SetOrderAll'], resolve)
		},
		meta: {
			title: '下单',
			index: 1,
			Auth: true,
		}
	},
	{
		path: '/myRepair/Detail',
		name: 'myrepairdetail',
		component: (resolve) => {
			require(['../views/myRepair/Detail'], resolve)
		},
		meta: {
			title: '收件人信息',
			index: 1,
			Auth: true,
		}
	},
	/* -- 代修接机单 路由 begin -- */
	{
		path: '/agentRepairCert/create',
		name: 'agentRepairCertificateCreate',
		component: (resolve) => {
			require(['../views/agentrepair/agentRepairCertificate/create'], resolve)
		},
		meta: {
			title: '代修创建接机单',
			index: 2,
			Auth: true,
			hideBack: true,
			transitionName: "updown"
		}
	},
	{
		path: '/agentRepairCert/check',
		name: 'agentRepairCertificateCheck',
		component: (resolve) => {
			require(['../views/agentrepair/agentRepairCertificate/check'], resolve)
		},
		meta: {
			title: '代修接机单客户签字',
			index: 2,
			Auth: true,
			hideBack: true,
			transitionName: "updown"
		}
	},
	{
		path: '/agentRepairCert/confirm',
		name: 'agentRepairCertificateConfirm',
		component: (resolve) => {
			require(['../views/agentrepair/agentRepairCertificate/confirm'], resolve)
		},
		meta: {
			title: '代修接机单',
			index: 3,
			Auth: true,
			transitionName: "updown"
		}
	},
	{
		path: '/agentRepairCert/smallTicket',
		name: 'agentRepairCertificateSmallTicket',
		component: (resolve) => {
			require(['../views/agentrepair/agentRepairCertificate/SmallTicket'], resolve)
		},
		meta: {
			title: '服务信息',
			index: 3,
			Auth: true,
			transitionName: "updown"
		}
	},
	{
		path: '/agentRepairCert/orderDetailSmallTicket',
		name: 'agentRepairOrderDetailSmallTicket',
		component: (resolve) => {
			require(['../views/agentrepair/agentRepairCertificate/SmallTicket'], resolve)
		},
		meta: {
			title: '服务信息',
			index: 4,
			Auth: true,
			transitionName: "updown"
		}
	},
	{
		path: '/agentRepairCert/standaloneSmallTicket',
		name: 'agentRepairStandaloneSmallTicket',
		component: (resolve) => {
			require(['../views/agentrepair/agentRepairCertificate/SmallTicket'], resolve)
		},
		meta: {
			title: '服务信息',
			index: 0,
			Auth: false
		}
	},
	{
		path: '/myOrder/list',
		name: 'myOrderlist',
		component: (resolve) => {
			require(['../views/agentrepair/myOrder/list'], resolve)
		},
		meta: {
			title: '代修订单',
			index: 2,
			Auth: true
		}
	},
	{
		path: '/myOrder/receiveexpress',
		name: 'myOrderreceiveexpress',
		component: (resolve) => {
			require(['../views/agentrepair/myOrder/receiveexpress'], resolve)
		},
		meta: {
			title: '发货信息',
			index: 4,
			Auth: true
		}
	},
	{
		path: '/refresh',
		name: 'refresh',
		component: (resolve) => {
			require(['../views/refresh'], resolve)
		},
		meta: {
			title: '刷新',
			index: 0,
			Auth: true
		}
	},
	/* -- 代修接机单 路由 end -- */
	/* 代修下单路由 */
	{
		path: '/agentrepair/index',
		name: 'agentrepairindex',
		component: (resolve) => {
			require(['../views/agentrepair/createOrder/index'], resolve)
		},
		meta: {
			title: '代修',
			index: 1,
			Auth: true
		}
	},
	{
		path: '/agentrepair/create',
		name: 'agentrepaircreate',
		component: (resolve) => {
			require(['../views/agentrepair/createOrder/create'], resolve)
		},
		meta: {
			title: '代修下单',
			index: 2,
			Auth: true
		}
	},
	{
		path: '/repaircenter/create',
		name: 'repaircentercreate',
		component: (resolve) => {
			require(['../views/agentrepair/createOrder/create'], resolve)
		},
		meta: {
			title: '到店代修下单',
			index: 3,
			Auth: true
		}
	},
	{
		path: '/myorder/detail',
		name: 'myorderdetail',
		component: (resolve) => {
			require(['../views/agentrepair/myOrder/detail'], resolve)
		},
		meta: {
			title: '订单详情',
			Auth: true,
			index: 3, //页面层级
			name: 'myorderdetail',
		}
	},{
		path: '/myorder/cancelorder',
		name: 'myordercancelorder',
		component: (resolve) => {
			require(['../views/agentrepair/myOrder/cancelOrder'], resolve)
		},
		meta: {
			title: '取消原因',
			Auth: true,
			index: 3, //页面层级
			name: 'myordercancelorder',
		}
	},
	{
		path: '/myorder/detailcancelorder',
		name: 'myorderdetailcancelorder',
		component: (resolve) => {
			require(['../views/agentrepair/myOrder/cancelOrder'], resolve)
		},
		meta: {
			title: '取消原因',
			Auth: true,
			index: 4, //页面层级
			name: 'myordercancelorder',
		}
	},
	{
		path: '/fixcenter',
		name: 'fixcenter',
		component: (resolve) => {
			require(['../views/agentrepair/orderCenter/Index'], resolve)
		},
		meta: {
			title: '维修中心',
			Auth: true,
			index: 1, //页面层级
			name: 'fixcenter',
		}
	},{
		path: '/fixcenter/orders',
		name: 'fcorders',
		component: (resolve) => {
			require(['../views/agentrepair/orderCenter/Orders'], resolve)
		},
		meta: {
			title: '代修订单',
			Auth: true,
			index: 4, //页面层级
			name: 'fcorders',
		}
	},{
		path: '/fixcenter/orderdroped',
		name: 'fixrepairorderdroped',
		component: (resolve) => {
			require(['../views/agentrepair/orderCenter/OrderDroped'], resolve)
		},
		meta: {
			title: '',
			Auth: true,
			index: 7, //页面层级
			name: 'fixrepairorderdroped',
			disableLR: true,
			hideBack: true,
			transitionName: 'updown'
		}
	},{
		path: '/fixcenter/orderend',
		name: 'fixrepairorderend',
		component: (resolve) => {
			require(['../views/agentrepair/orderCenter/OrderEnd'], resolve)
		},
		meta: {
			title: '',
			Auth: true,
			hideBack: true,
			index: 7, //页面层级
			name: 'fixrepairorderend',
			disableLR: true,
			transitionName: 'updown'
		}
	},
	{
		path: '/agentrepair/ordercenter/detail',
		name: 'ordercenterdetail',
		component: (resolve) => {
			require(['../views/agentrepair/orderCenter/detail'], resolve)
		},
		meta: {
			title: '订单详情',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/fixcenter/abandonorder/:id',
		name: 'fcabandonorder',
		component: (resolve) => {
			require(['../views/agentrepair/orderCenter/AbandonOrder'], resolve)
		},
		meta: {
			title: '选择商家取货方式',
			Auth: true,
			index: 6, //页面层级
			name: 'fcabandonorder',
		}
	},
	{
		path: '/store/onecode',
		name: 'stonecode',
		component: (resolve) => {
			require(['../views/store/onecode'], resolve)
		},
		meta: {
			title: '一物一码绑定',
			Auth: true,
			index: 6, //页面层级
			name: 'stonecode',
		}
	},
	{
		path: '/store/address',
		name: 'staddress',
		component: (resolve) => {
			require(['../views/store/address'], resolve)
		},
		meta: {
			title: '一物一码绑定',
			Auth: true,
			index: 6, //页面层级
			name: 'staddress',
		}
	},
	{
		path: '/pageservice',
		name: 'pageservice',
		component: (resolve) => {
			require(['../views/order/PageService'], resolve)
		},
		meta: {
			title: '服务码',
			Auth: true,
			index: 6, //页面层级
			name: 'pageservice',
		}
	},
	/*App专用路由*/
	{
		path: '/app/login',
		name: 'appLogin',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '',
			index: 1,
			Auth: false,
			app: true
		}
	},
	{
		path: '/app/createorder',
		name: 'appCreateOrder',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '下单',
			index: 1,
			Auth: false,
			app: true,
			path: '/order/setorder'
		}
	},
	{
		path: '/app/storeadd',
		name: 'appStoreAdd',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '零采入库',
			index: 1,
			Auth: false,
			app: true,
			path: '/store/add'
		}
	},
	{
		path: '/app/support',
		name: 'appSupport',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '售后',
			index: 1,
			Auth: false,
			app: true,
			path: '/support'
		}
	},
	{
		path: '/app/recycle',
		name: 'appRecycle',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '回收',
			index: 1,
			Auth: false,
			app: true,
			path: '/recycle'
		}
	},
	{
		path: '/app/agentrepair',
		name: 'appAgentRepair',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '代修',
			index: 1,
			Auth: false,
			app: true,
			path: '/agentrepair/create'
		}
	},
	{
		path: '/app/staff',
		name: 'appStaff',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '员工管理',
			index: 1,
			Auth: false,
			app: true,
			path: '/staff/list'
		}
	},
	{
		path: '/app/orderlist',
		name: 'appOrderList',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '订单列表',
			index: 1,
			Auth: false,
			app: true,
			path: '/order/list'
		}
	},
	{
		path: '/app/myorderlist',
		name: 'appMyOrderList',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '代修订单',
			index: 1,
			Auth: false,
			app: true,
			path: '/myorder/list'
		}
	},
	{
		path: '/app/fixorderlist',
		name: 'appFixOrderList',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '技术中心订单',
			index: 1,
			Auth: false,
			app: true,
			path: '/fixcenter/orders'
		}
	},
	{
		path: '/app/storelist',
		name: 'appStoreList',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '门店列表',
			index: 1,
			Auth: false,
			app: true,
			path: '/store/list'
		}
	},
	{
		path: '/app/settlement',
		name: 'appSettlement',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '资金',
			index: 1,
			Auth: false,
			app: true,
		}
	},
	{
		path: '/app/registerprotocol',
		name: 'appRegisterprotocol',
		component: (resolve) => {
			require(['../views/app/registerprotocol'], resolve)
		},
		meta: {
			title: '注册协议',
			index: 1,
			Auth: false,
			app: true,
		}
	},
	{
		path: '/app/about',
		name: 'appAbout',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '关于我们',
			index: 1,
			Auth: false,
			app: true,
			path: '/about'
		}
	},
	{
		path: '/app/announcement',
		name: 'appAnnouncement',
		component: (resolve) => {
			require(['../views/app/bridge'], resolve)
		},
		meta: {
			title: '通知中心',
			index: 1,
			Auth: false,
			app: true,
			path: '/announcement'
		}
	},
	{
				path: '/app/shopAddress',
				name: 'appshopAddress',
				component: (resolve) => {
						require(['../views/app/bridge'], resolve)
				},
				meta: {
						title: '门店信息',
						index: 1,
						Auth: false,
						app: true,
						path: '/shop/shopAddress'
				}
	},
	//服务端
	{
		path: '/server/delivery',
		name: 'delivery',
		component: (resolve) => {
			require(['../views/server/Delivery'], resolve)
		},
		meta: {
			title: '取件单',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/server/deliverySure',
		name: 'deliverySure',
		component: (resolve) => {
			require(['../views/server/DeliverySure'], resolve)
		},
		meta: {
			title: '取件单',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/server/positiveComment',
		name: 'positiveComment',
		component: (resolve) => {
			require(['../views/server/PositiveComment'], resolve)
		},
		meta: {
			title: '取件单',
			Auth: true,
			index: 2
		}
	},
	{
		path: '/selectshop',
		name: 'selectshop',
		component: (resolve) => {
			require(['../views/order/select-shop'], resolve)
		},
		meta: {
			title: '选择网点',
			Auth: true,
			index: 1
		}
		},
		{
				path: '/order/ActivateQ',
				name: 'ActivateQ',
				component: (resolve) => {
						require(['../views/order/ActivateQ'], resolve)
				},
				meta: {
						backMessage: '返回维修',
						title: '激活质保',
						Auth: true,
						index: 1
				}
		},
		{
				path: '/order/ActivateQResult',
				name: 'ActivateQResult',
				component: (resolve) => {
						require(['../views/order/ActivateQResult'], resolve)
				},
				meta: {
						backMessage: '返回维修',
						title: '激活结果',
						Auth: true,
						index: 1
				}
		},
		{
				path: '/shop/shopAddress',
				name: 'shopAddress',
				component: (resolve) => {
						require(['../views/shop/shopAddress'], resolve)
				},
				meta: {
						title: '门店信息',
						Auth: true,
						index: 1
				}
		},
		{
				path: '/shop/shopAddressEdit',
				name: 'shopAddressEdit',
				component: (resolve) => {
						require(['../views/shop/shopAddressEdit'], resolve)
				},
				meta: {
						title: '门店信息编辑',
						Auth: true,
						index: 1
				}
		},
		{
				path: '/shop/shopImgEdit',
				name: 'shopImgEdit',
				component: (resolve) => {
						require(['../views/shop/shopImgEdit'], resolve)
				},
				meta: {
						title: '更换门店图片',
						Auth: true,
						index: 1
				}
		},
		{
				path: '/shop/shopImgStatus',
				name: 'shopImgStatus',
				component: (resolve) => {
						require(['../views/shop/shopImgStatus'], resolve)
				},
				meta: {
						title: '更换门店图片',
						Auth: true,
						index: 1
				}
		},
		{
				path: '/kf',
				name: 'kf',
				component: (resolve) => {
						require(['../views/kf'], resolve)
				},
				meta: {
						title: '联系客服',
						Auth: true,
						index: 1
				}
		},
		{
				path: '/app/kf',
				name: 'appkf',
				component: (resolve) => {
						require(['../views/app/bridge'], resolve)
				},
				meta: {
						title: '联系客服',
						index: 1,
						Auth: false,
						app: true,
						path: '/kf'
				}
		},
]

var router = new VueRouter({
	routes,
	mode
})

// router.beforeEach((to, from, next) => {
// 	next();
// })

router.beforeEach((to, from, next) => {
	if (navigator.userAgent.indexOf("QJWAPP") < 0) {
		store.dispatch('Account/getUser');
		if(to.meta.public) {
			next()
		}
		else if (!to.meta.Auth) {
			if (!!store.state.Account && store.state.Account.loginResult.status) {
				next({
					path: '/'
				});
			} else {
				next();
			}
		} else {
			if (!!store.state.Account && store.state.Account.loginResult.status) {
				next();
			} else {
				next({
					path: '/login',
					query: { redirect: to.fullPath }
				});
			}
		}
	}else{
		next();
	}
})

router.onError((err) => {
	const pattern = /Loading chunk (\d)+ failed/g;
	const isChunkLoadFailed = err.message.match(pattern);
	if (isChunkLoadFailed) {
		let chunkError = sessionStorage.getItem('chunkError');
		let nowTimes = Date.now();

		//路由跳转报错,href手动跳转
		if (chunkError === null || chunkError && nowTimes - parseInt(chunkError) > 60000) {
			sessionStorage.setItem('chunkError', 'reload');
			const targetPath = routers.history.pending.fullPath;
			window.location.href = window.location.origin + targetPath;
		} else if (chunkError === 'reload') { //手动跳转后依然报错,强制刷新
			sessionStorage.setItem('chunkError', Date.now());
			window.location.reload(true);
		}
	}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js